import React from 'react';

export const VOLTAGE_STATUS = {
	GOOD: 'GOOD',
	NORMAL: 'NORMAL',
};

export const VOLTAGE_STATUS_KO = {
	[VOLTAGE_STATUS.GOOD]: '정상',
	[VOLTAGE_STATUS.NORMAL]: '양호',
};

// voltageDeviationStatus → 한글 상태값. 매칭 안되거나 데이터 없으면 null
export const getVoltageStatusKo = (status) => (status ? (VOLTAGE_STATUS_KO[status.toUpperCase()] ?? null) : null);

// 소수점 데이터 노출: null → '-', 정수(0 포함) → toFixed(1), 소수 → 응답값 그대로 + 단위
export const formatEvDecimal = (value, unit = '') => {
	if (value == null) return '-';
	return `${Number.isInteger(value) ? value.toFixed(1) : value}${unit}`;
};

// JATO 원본값 중 미지원으로 판단하는 값 (없음, 알수 없음)
const JATO_NONE_VALUES = ['없음', '알수 없음', '알수없음'];

// V2L, OTA, 열관리 시스템 공통 가공
// 없음/알수없음/데이터없음 → notSupportLabel, 그 외(있음 등) → '지원'
// 화면별로 미지원 표기 notSupportLabel 로 구분
export const toJatoSupportLabel = (value, notSupportLabel = '미지원') => {
	if (!value || JATO_NONE_VALUES.includes(value)) return notSupportLabel;
	return '지원';
};

export const EV_BOTTOMSHEET_CONTENTS = {
	v2l: {
		title: <>V2L (Vehicle to Load)</>,
		content: (
			<p>
				차량에 저장된 에너지를 외부로 꺼내어 일반 220V 전원처럼 사용할 수 있는 양방향 충전 기능입니다. 발전기나 보조배터리 없이도 캠핑이나
				차박과 같은 야외 활동에서도 전기를 사용할 수 있어요.
			</p>
		),
	},
	soh: {
		title: '배터리 성능지수',
		content: (
			<p>
				LG에너지솔루션의 빅데이터로 예상한 배터리 상태 수치예요. 누적 3만 대 이상의 차량 분석 결과를 바탕으로, 현재 이 차의 배터리 상태를 %로
				보여줘요.
			</p>
		),
	},
	BMSSoH: {
		title: 'BMS SoH',
		content: <p>차량 배터리 관리 시스템(BMS)이 자체 로직으로 연산한 배터리의 일차적 건강 상태(성능 비율, %)예요.</p>,
	},
	voltageGrade: {
		title: '전압 편차',
		content: (
			<p>
				배터리 팩을 구성하는 개별 셀 간의 전압이 얼마나 균일한지 보는 지표예요.
				<br />
				전기차 배터리는 수백 개의 셀로 이뤄져 있고, 셀 간 전압 편차가 작을수록 효율과 안전성이 높아요.
				<br />
				B.once는 셀의 전압 불균형을 확인하고 유의미한 편차에 대해 가이드를 제공해요.
			</p>
		),
	},
	ota: {
		title: 'OTA 시스템',
		content: (
			<p>
				스마트폰처럼 차량 소프트웨어를 원격으로 자동 업데이트 하는 기술이에요. 정비소에 직접 방문하지 않아도 새로운 편의 기능이 나올 때마다 내
				차에 자동으로 추가되어, 언제나 최신 상태의 차를 타는 듯한 경험을 제공합니다.
			</p>
		),
	},
	thermal: {
		title: '열 관리 시스템',
		content: (
			<p>
				열관리 시스템은 배터리팩 내부 온도를 실시간으로 모니터링하여 최적의 작동 범위로 온도를 유지해요, 고온으로 인한 배터리 노호와 화재
				위험을 방지하고, 주행 거리 감소와 충전 성능 저하를 막아 배터리의 수명과 안정성을 극대화하는 역할을 합니다.
			</p>
		),
	},
};

// 배터리 PASS 안내사항·유의사항 — '배터리 인증 전기차 랜딩'과 '배터리 성능 탭'에서 사용
export const BATTERY_PASS_GUIDE_TEXT =
	'엔카는 배터리PASS 기준에 따라 진단하고 기준치 이상 배터리 성능지수가 하락하는 경우, 내부 보상 규정에 따라 차량을 구입한 구매자에게 위로금이 지급됩니다.';

export const BATTERY_PASS_CAUTION_ITEMS = [
	"배터리 PASS는 LG에너지솔루션이 제공하는 데이터를 기반으로 산출되며, 엔카의 '엔카진단'·'성능' 정보와는 다른 항목을 점검합니다.",
	'배터리 PASS 결과는 측정 시점을 기준으로 확인한 정보입니다. 배터리 상태는 온도·주행 습관·충전 환경 등에 따라 달라질 수 있습니다.',
	'배터리 PASS는 차량의 현재 배터리 상태를 확인하는 정보로, 향후 배터리 성능을 보증하는 자료는 아닌 점 참고 부탁드립니다.',
];
